const $ = jQuery.noConflict();


'use strict';
const RegisterForm = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		$(document).ready(function() {
			RegisterForm.formSettings();
			RegisterForm.phoneFieldVal();
			RegisterForm.conditionalFields();
			$(document).on('click', '.js-register__btn', function() {
				$('.js-response-msg-register').text('');
				$('.js-register__btn').css('pointer-events', 'none');
			});

			function inpNum(e) {
				e = e || window.event;
				const charCode = (typeof e.which === 'undefined') ? e.keyCode : e.which;
				const charStr = String.fromCharCode(charCode);
				if (!charStr.match(/^[0-9]+$/)) {
					e.preventDefault();
				}
			}

			$('input[type="number"]').on('keypress', function() {
				inpNum();
			});
			$('form').on('focus', 'input[type=number]', function() {
				$(this).on('wheel.disableScroll', function(e) {
					e.preventDefault();
				});
			});
			$('form').on('blur', 'input[type=number]', function() {
				$(this).off('wheel.disableScroll');
			});
		});
	},

	phoneFieldVal() {
		const inputs = document.querySelectorAll('#register-form-wc .js-reg-phone');

		if (inputs.length < 1) {
			return;
		}

		const onlyNum = function() {
			const numbers = this.value.replace(/\D/g, '');
			this.value = numbers.substring(0, 9);
		};

		for (let i = 0; i < inputs.length; i++) {
			inputs[i].addEventListener('keyup', onlyNum);
			inputs[i].addEventListener('input', onlyNum);
			inputs[i].addEventListener('change', onlyNum);
		}


	},

	formSettings: function() {

		// override default error message
		$.validator.messages.required = 'Polje je obavezno';

		$('#register-form-wc').validate({
			rules: {
				'reg-username': {
					required: true,
				},
				'reg-fname': {
					required: true,
				},
				'reg-lname': {
					required: true,
				},
				'reg-email': {
					required: true,
					email: true
				},
				'reg-phone': {
					required: true,
					minlength: 9
				},
				'reg-pass': {
					required: true,
					minlength: 12,
				},
				'reg-pass2': {
					required: true,
					minlength: 12,
					equalTo: '#reg-pass'
				},
				'reg-city': {
					required: true,
				},
				'reg-zip': {
					required: true,
				},
				'reg-address': {
					required: true,
				},
				'reg-company-name': {
					required: true,
				},
				'reg-email-company': {
					required: true,
				},
				'reg-phone-company': {
					required: true,
					minlength: 9
				},
				'reg-identification-num': {
					required: true,
				},
				'reg-tax-id': {
					required: true,
				}
			},
			messages: {
				'reg-email': {
					email: 'Email nije validan'
				},
				'reg-phone': {
					minlength: 'Molim vas unestite 9 brojeva',
				},
				'reg-phone-company': {
					minlength: 'Molim vas unestite 9 brojeva',
				},
				'reg-pass': {
					minlength: 'Molim vas unestite bar 12 karaktera',
				},
				'reg-pass2': {
					required: 'Potvrdite lozinku',
					minlength: 'Lozinke se ne poklapaju',
					equalTo: 'Lozinke se ne poklapaju'
				},
			},
			invalidHandler: function(form, validator) {
				if (!validator.numberOfInvalids()) {
					return;
				}

				$('html, body').animate({
					scrollTop: $(validator.errorList[0].element).offset().top - 200
				}, 500);
				$('.js-btn-loader').removeClass('is-visible');
				$('.js-register__btn').css('pointer-events', 'auto');

			},
			submitHandler: function(form) {

				const inputs = form.querySelectorAll('input');
				const data = {};
				for (let i = 0; i < inputs.length; i++) {
					const attrName = inputs[i].getAttribute('name');
					const value = inputs[i].value;
					if (attrName !== '' && value !== '') {
						if (attrName === 'radio-group') {
							data[attrName] = $('input[name="radio-group"]:checked').val();
						} else {
							data[attrName] = value;
						}
					}
				}
				const ajaxData = {
					action: 'register_user_wc_custom',
					data
				};

				RegisterForm.ajaxFunction(ajaxData);
			}
		});
	},

	conditionalFields: function() {
		$('#register-radio-individual').trigger('click');
		$('input[name="radio-group"]').on('change', function() {
			if ($(this).val() === '1') {
				$('input[name="reg-email"]').rules('add', 'required');
				$('input[name="reg-phone"]').rules('add', 'required');
				$('input[name="reg-company-name"]').rules('remove', 'required');
				$('input[name="reg-email-company"]').rules('remove', 'required');
				$('input[name="reg-phone-company"]').rules('remove', 'required');
				$('input[name="reg-identification-num"]').rules('remove', 'required');
				$('input[name="reg-tax-id"]').rules('remove', 'required');
			}

			if ($(this).val() === '2') {
				$('input[name="reg-email"]').rules('remove', 'required');
				$('input[name="reg-phone"]').rules('remove', 'required');
				$('input[name="reg-company-name"]').rules('add', 'required');
				$('input[name="reg-email-company"]').rules('add', 'required');
				$('input[name="reg-phone-company"]').rules('add', 'required');
				$('input[name="reg-identification-num"]').rules('add', 'required');
				$('input[name="reg-tax-id"]').rules('add', 'required');
			}
		});
	},

	ajaxFunction: function(data) {
		$.ajax({
			datatype: 'json',
			type: 'POST',
			/* eslint-disable */
			url: techno_ferum_ajax.ajax_url,
			/* eslint-disable */
			data,
			success: function(response) {
				const msgHolder = $('.js-response-msg-register');
				if (response.success) {
					msgHolder.addClass('success');
					msgHolder.text('Uspešno ste se registrovali, uskoro će te biti preusmereni.');
					setTimeout(function() {
						location.href = response.data;
					}, 3000);
				} else {
					msgHolder.text(response.data[0].message);
				}

				$('.js-btn-loader').removeClass('is-visible');
				$('.js-register__btn').css('pointer-events', 'auto');
			}
		});
	}
};

export default RegisterForm;
